"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _guacWidgetCore = require("@wsb/guac-widget-core");

var _dataAids = _interopRequireDefault(require("../../constants/dataAids"));

var _BookingDetailsContent = _interopRequireDefault(require("./BookingDetailsContent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var styles = {
  bookingDetailsQuestion: {
    marginBottom: 'medium'
  }
};

var BookingQuestionsDetails = function BookingQuestionsDetails(_ref) {
  var answeredQuestions = _ref.answeredQuestions,
      i18n = _ref.i18n;
  if (!answeredQuestions || !answeredQuestions.length) return null;
  var _UX2$Element = _guacWidgetCore.UX2.Element,
      Block = _UX2$Element.Block,
      Label = _UX2$Element.Label,
      Details = _UX2$Element.Details;
  return /*#__PURE__*/_react["default"].createElement(_BookingDetailsContent["default"], {
    icon: "questionBubble"
  }, answeredQuestions.map(function (_ref2) {
    var answer = _ref2.answer,
        question = _ref2.question;
    return /*#__PURE__*/_react["default"].createElement(Block, {
      key: "question-".concat(question.id),
      style: styles.bookingDetailsQuestion
    }, /*#__PURE__*/_react["default"].createElement(Label.Minor, {
      "data-aid": _dataAids["default"].BOOKING_QUESTIONS_QUESTION
    }, question.body), /*#__PURE__*/_react["default"].createElement(Details, {
      "data-aid": _dataAids["default"].BOOKING_QUESTIONS_ANSWER
    }, answer.body || i18n.na));
  }));
};

BookingQuestionsDetails.propTypes = {
  answeredQuestions: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    question: _propTypes["default"].shape({
      body: _propTypes["default"].string.isRequired
    }),
    answer: _propTypes["default"].shape({
      body: _propTypes["default"].string
    })
  })).isRequired,
  i18n: _propTypes["default"].shape({
    na: _propTypes["default"].string.isRequired
  })
};
var _default = BookingQuestionsDetails;
exports["default"] = _default;